module.exports = __webpack_public_path__ + "img/c5202009-2.e49b55b2.jpg";